import { useSearchParams } from "react-router-dom"

interface TraceparentResult {
	traceparent: string | null
	traceId: string | undefined
}

export const useTraceparent = (): TraceparentResult => {
	const [searchParams] = useSearchParams()
	const traceparent = searchParams.get("traceparent")
	const traceId = traceparent?.split("-")[1]

	return { traceparent, traceId }
}
